import React from 'react';
import { graphql } from 'gatsby';
import classnames from 'classnames';
import SanityPortableText from '../SanityPortableText';
import Image from 'gatsby-plugin-sanity-image';
import Card from '../Card';

import PancakeIntro from '../PancakeIntro';
import Pancake from './Pancake';
import Container from '../Container';
import Button from '../Button';

import './CaseStudies.scss';

const Benefits = (props) => {
  const { title, text, caseStudies, logos, callToAction, theme, className } =
    props;

  return (
    <Pancake className={classnames('PancakeBenefits', className)} theme={theme}>
      <Container>
        {(title || text) && <PancakeIntro title={title} text={text} />}
        {caseStudies?.length > 0 && (
          <div className="CaseStudiesPancakeGrid">
            {caseStudies.map((caseStudy) => (
              <Card theme="Light" paddingSize="Double" clickable>
                <Card.Image>
                  {caseStudy.company?.logoFullColorDark && (
                    <Image {...caseStudy.company.logoFullColorDark} alt={''} />
                  )}
                </Card.Image>
                <Card.CTA>
                  <Button
                    className="corporate-light transparent full"
                    to={`/customers/${caseStudy.slug?.current}/`}
                    arrow
                  >
                    Case Study
                  </Button>
                </Card.CTA>
              </Card>
            ))}
          </div>
        )}

        {logos?.length > 0 && (
          <div className="CaseStudiesLogos">
            {logos.map((logo) => {
              return (
                <img
                  src={logo.logoFullColorDark.asset?.url}
                  alt={logo.name}
                  loading="lazy"
                />
              );
            })}
          </div>
        )}
        {callToAction?.url && callToAction?.label && (
          <div className="CaseStudiesCTA">
            <Button
              to={callToAction?.url}
              className="corporate-light with-shadow"
              arrow
            >
              {callToAction?.label}
            </Button>
          </div>
        )}
      </Container>
    </Pancake>
  );
};

export const query = graphql`
  fragment SanityPancakeCaseStudies on SanityPancakeCaseStudies {
    _key
    _type
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
    caseStudies {
      company {
        logoFullColorDark {
          ...ImageWithPreview
        }
      }
      slug {
        current
      }
    }
    callToAction {
      url
      label
    }
    logos {
      logoFullColorDark {
        asset {
          url
        }
      }
    }
    theme
  }
`;

export default Benefits;
